import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { RegisterTitle, RegisterUser } from "../../utils/Constant";
import RegistrationTabs from "../Registration/RegistrationTabs";


const RegistrationContainer = () => {
  return (
    <>
      {/* Breadcrumbs (top navigation) */}
      <Breadcrumbs mainTitle={RegisterTitle} parent={RegisterUser} />

      {/* Page Container */}
      <Container fluid className="edit-profile">
        <Row>
          {/* Registration Form (Formik) */}
          <RegistrationTabs/>
        </Row>
      </Container>
    </>
  );
};

export default RegistrationContainer;
